import React from 'react';
import { NavLink } from 'react-router-dom';
import './event.css';
import img from '../Events/image.jpeg';
import img1 from './microfest.png';
import img2 from './Pharmacist Day.png';
import img3 from './week.jpeg';
const events = [
    {
        title: "Bhawishyam",
        date: "Mon-Wed, Nov 6-8",
        description: "BHAWISHYAM, a three-day collaboration with Horizon Science Society, included diverse workshops, notably a CPR session led by Dr. SK Singh. A panel discussion with faculties and esteemed guest Dr. Bhaswati Ganguli enriched perspectives. Mr. Aditya Rallapalli's insights on Chandrayaan 3 and engaging chess tournaments added intellectual excitement. The vibrant cultural evening, Kalasangam, marked a lively conclusion to the event. ",
        image: img
    },
    {
        title: "Pharmacist Day",
        date: "Mon, Sep 25",
        description: "Pharmacist Day at SOHST featured impactful skits, a quiz, and a debate on healthcare. Creative competitions and nutritious food stalls added flair. Support from the Vice-Chancellor, Registrar, and dignitaries like Dr. Dhan Singh Rawat and Dr. Farooq elevated the event. An award ceremony and a Dean's vote of thanks concluded the day, harmonizing education, creativity, and community engagement. ",
        image: img2
    },
    {
        title: "Microfest",
        date: "Thu, Sep 21",
        description: "MicroFest,by Ozone Student Society and SOHST's Microbiology Department, featured addresses by the Dean, Cluster Heads, and Guest of Honour Dr. V. Samuel Raj, with dance, band performances, a quiz, and a talk on antibiotic resistance. Creative competitions, a surprise flashmob, and an award ceremony concluded the event, leaving a lasting impression. ",
        image: img1
    },
    {
        title: "PHARMOCOVIGLANCE WEEK",
        date: "Sun-Sat, Sep 17-23",
        description: "Pharmacovigilance Week spanned seven days, featuring orientation, expert talks by Dr. S. K. Singh and Dr. Shubham Dwivedi, and awareness campaigns. Days 5 and 6 prepared students and included a face painting competition. The concluding Day 7 featured a ceremony and awards, marking the initiative's success in educating and engaging the community. ",
        image: img3
    }
];

const handleNavLinkClick = () => {
    window.scrollTo(0, 0);
};

const EventData = ({ title, date, description, image }) => (
    <div className="item-container">
        <div className="img-container">
            <img src={image} alt="img" />
        </div>
        <div className="body-container">
            <div className="overlay"></div>
            <div className="event-info">
                <p className="title">{title}</p>
                <div className="separator"></div>
                <div className="additional-info">
                    <p className="info">
                        <i className="far fa-calendar-alt"></i>
                        {date}
                    </p>
                    <p className="info description">
                        {description}
                        <NavLink to={`/event/${title.toLowerCase().replace(/\s+/g, '-')}`} onClick={handleNavLinkClick} className="nav">
                            More info.
                        </NavLink>
                    </p>
                </div>
            </div>
        </div>
    </div>
);
const Event = () => (
    <div>
        <div className="heading">
            <h1>Our Events</h1>
        </div>
        <div className="container2">
            {events.map((eventData, index) => (
                <EventData key={index} {...eventData} index={index} />
            ))}
        </div>
    </div>
);

export default Event;
